import { IGlobalStore } from 'modules/types';
import { createSelector } from "reselect";


export const getErrorState = (state: IGlobalStore) => state.error;

export const getErrorMessage = createSelector(
	getErrorState,
	({ text }) => text
);
